import { useRouteLoaderData } from "react-router";
import type { loader as rootLoader } from "~/root";

/**
 * @returns the request toast from the root loader
 */
export function useRequestToast() {
  const data = useRouteLoaderData<typeof rootLoader>("root");

  return data?.toast ?? undefined;
}
